import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import {LorenAuthenticationService} from '../../services/loren-authentication-service/loren-authentication.service';

@Directive({
    selector: '[lorenShowForRoles]',
    standalone: false
})
export class LorenShowForRoleDirective implements OnInit {
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private authenticationService = inject(LorenAuthenticationService);
    private viewContainer = inject(ViewContainerRef);


    requiredRoles: string[] = [];

    @Input() set lorenShowForRoles(role: string[]) {
        this.requiredRoles = role;
    }

    ngOnInit() {
        if (!this.requiredRoles || this.requiredRoles.length === 0) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }

        const userRoles = this.authenticationService.getRoles();
        // if user has one of required roles
        if (userRoles.some(x => this.requiredRoles.includes(x))) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
